module.exports = __webpack_public_path__ + "static/media/5-fruits.e5d9e503.jpg";